import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "./../../redux/actions/menuActions";
import MenuDevs from "./Menu";
import _ from "lodash";
import AuthRender from "../../containers/AuthRender";
import { SERVICES } from "../../configs/constants";
import { Route, Redirect } from "react-router";
class DevHome extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("devs");
    this.props.setMenuLeftIndex("home");
    this.props.setMenuLeftItemIndex("");
    this.props.setMenuLeftContent(MenuDevs);
  }
  render() {
    return (
      <div className="p-landing">
        CONTENU
        <br />
        DISPONIBLE
        <br />
        PROCHAINEMENT
        <br />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || 0;
  const currentUser = state.userInfos || {};
  const currentUserClients = currentUser.clients || [];
  const currentUserClient = _.find(currentUserClients, { id: currentClientId }) || {};
  const currentUserClientServices = currentUserClient.services || [];

  return {
    currentServices: currentUserClientServices,
    currentRoleId: currentUser.role_id || 100
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DevHome);



// WEBPACK FOOTER //
// src/pages/devs/Devs.home.js